"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const svgTemplates_1 = require("./svgTemplates");
const render_1 = require("./render");
const SCALE_SVG_WIDTH = 150;
const SCALE_SVG_HEIGHT = 5;
const suffixMap = {
    '00 Mb': 100000000,
    '0 Mb': 10000000,
    'Mb': 1000000,
    '00 Kb': 100000,
    '0 Kb': 10000,
    'Kb': 1000,
    '00 bp': 100,
    '0 bp': 10,
    'bp': 1,
};
function scaleSvg() {
    const options = this;
    const { scale, show_scale, svg_width, svg_space, svg_height } = options;
    if (!show_scale)
        return options;
    const svgContents = [];
    const basesPer1Px = 1 / scale;
    let scaleBases = basesPer1Px * SCALE_SVG_WIDTH;
    let text = '';
    const suffixs = Object.keys(suffixMap).sort((a, b) => suffixMap[b] - suffixMap[a]);
    for (let suffix of suffixs) {
        const unit = suffixMap[suffix];
        if (scaleBases > unit) {
            const count = Number((scaleBases / unit).toFixed(0));
            scaleBases = count * unit;
            text = `${count}${suffix}`;
            break;
        }
    }
    const scaleX = svg_width * (1 - svg_space / 2) - scaleBases * scale;
    const scaleY = svg_height * 0.9;
    svgContents.push((0, render_1.renderItem)(svgTemplates_1.SVG_SCALE_LINE, {
        x1: scaleX,
        y1: scaleY - SCALE_SVG_HEIGHT,
        x2: scaleX,
        y2: scaleY,
        x3: scaleX + scaleBases * scale,
        y3: scaleY,
        x4: scaleX + scaleBases * scale,
        y4: scaleY - SCALE_SVG_HEIGHT,
    }));
    const textWidth = options.label_font_size * text.length / 2;
    svgContents.push((0, render_1.renderItem)(svgTemplates_1.SVG_SCALE_TEXT, {
        x: scaleX + (scaleBases * scale - textWidth) / 2,
        y: scaleY - 2 * SCALE_SVG_HEIGHT,
        fontSize: options.label_font_size,
        text,
    }));
    if (!options.svg_template)
        options.svg_template = [];
    options.svg_template.push({ content: svgContents });
    return options;
}
exports.default = scaleSvg;
